@if(!menu_selected()){
    <div class="non-route">
        <div class="search-bar">
            <h1 class="font-extrabold mb-10">Browse Restaurant Menus</h1>
            <input matInput [placeholder]="placeholder" aria-label="Search" [formControl]="search" type="text" (keydown.enter)="onSearch()" normal autocomplete="off"/>
            <a class="btn package-button" (click)="onSearch()" aria-label="Search">
                <mat-icon>search</mat-icon>
            </a>
        </div>
        @if(qr_instructions()){
            <div class="qr-instructions" paint="plan">
                @if(qr_view()){
                    <div class="qr-input">
                        <h2 class="m-0">
                            Input below the number under the QR code.
                        </h2>
                        <div class="custom-field" [class.has-error]="!!qrcode.errors">
                            <input matInput placeholder="12345678" [formControl]="qrcode" autocomplete="off">
                            <div class="prefix"><p class="m-0">MT</p></div>
                            <ng-container *ngTemplateOutlet="errorRender; context: { $implicit: qrcode, label: 'Code' }"></ng-container>
                        </div>
                        <div class="actions">
                            <button mat-flat-button (click)="qr_view.set(false); qrcode.reset('', { emitEvent: false })">INFO</button>
                            <button mat-flat-button (click)="onQRCode()">VIEW MENU</button>
                        </div>
                    </div>
                } @else {
                    <img src="/old/banner-qr.png" alt="QR Code Instructions"/>
                    <div class="enter-code-btn">
                        <button mat-flat-button class="font-extrabold" (click)="qr_view.set(true);">ENTER CODE</button>
                    </div>
                    <button mat-icon-button class="dismiss" (click)="dismissed.set(true)"><mat-icon>clear</mat-icon></button>
                }
            </div>
        }
        <div class="go-back-container" [@step]="{ value: menu_source() == 'brand', params: { height: 0 } }">
            <a class="go-back package-button" mat-flat-button paint="plan-bg" routerLink="/menus">
                <mat-icon>arrow_back</mat-icon>
                <span>BACK TO MENU SEARCH</span>
            </a>
        </div>
    </div>
}
<div class="sub-router" [class.with-button]="menu_source() == 'brand'">
    <router-outlet (activate)="onRoute($event)"></router-outlet>
</div>

<ng-template #errorRender let-field let-label="label">
    @if(field?.touched && field?.errors; as error){
      <mat-error>
        @if(error.required){
            Please enter the 8 digit code.
        } @else if(error.pattern){
            {{label}} should be 8 digits long.
        } @else if(error.badCode){
            {{label}} seems to be incorrect.
        } @else {
          {{label}} is invalid
        }
      </mat-error>
    } @else {
      <mat-hint>&nbsp;</mat-hint>
    }
  </ng-template>